import { useNavigate } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    /* 🔐 AUTH */
    localStorage.removeItem("token");
    localStorage.removeItem("workerID");

    /* 🧹 CLEAR TEMP SESSION DATA */
    sessionStorage.clear();

    /* ❌ REMOVE OLD GROUP UI CACHE (OPTIONAL) */
    localStorage.removeItem("currentGroupName");
    localStorage.removeItem("workerStatus");

    /* ➡️ REDIRECT */
    navigate("/");
  };

  return (
    <button onClick={handleLogout} style={logoutBtn}>
      <FaSignOutAlt /> Logout
    </button>
  );
};

export default LogoutButton;


const logoutBtn = {
  marginLeft: "auto",
  background: "transparent",
  border: "1px solid #fff",
  color: "#fff",
  padding: "8px 14px",
  borderRadius: "8px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "14px"
};
